module.exports = __webpack_public_path__ + "img/3.1.1d77e613.png";